export default "__VITE_ASSET__B$TQmfW0__"